import React, { useState, useEffect } from "react";
import { getData } from "app/data";
import { FormattedMessage } from "react-intl";
import "./CommonUseCases.css"
import { Link } from "react-router-dom";

const Index = ({ data }) => {
  const useCaseData = getData(data);
  const [useCase, setUseCase] = useState(useCaseData[0].title);
  const [description, setDescription] = useState(useCaseData[0].desc);
  const [img, setImg] = useState(useCaseData[0].img);
  const [id, setId] = useState(useCaseData[0].id);
  const [activeId, setActiveId] = useState(1);
  const [link, setLink] = useState("/use-case-restaurant-ordering-solution");

  useEffect(() => {
    showUseCases();
  }, [useCase]);

  const showUseCases = () => {
    useCaseData.map((item) =>
      item.title === useCase ? setDescription(item.desc) : null
    );
    useCaseData.map((item) =>
      item.img === useCase ? setImg(item.img) : null
    );
    useCaseData.map((item) => (item.title === useCase ? setId(item.id) : null));
    useCaseData.map((item) =>
      item.title === useCase ? setLink(item.link) : null
    );


  };

  return (
    <section className="isGoopter">
      <div className="header">
        <h2>
          <FormattedMessage id={"use_case_sec_header_title"} />
        </h2>
        <p>
          <FormattedMessage id={"use_case_sec_header_desc"} />
        </p>
        <p className="accent">
          <FormattedMessage id={"use_case_sec_header_desc2"} />
        </p>
      </div>
      <div className="contents">
        <div className="container  row mx-auto">
          <div className="col-lg-3 col-sm-12 right-border">
            <div className="contens-nav-wrapper">
              <ul className="contentsNav">
                {useCaseData.map((item) => (
                  <a
                    className={item.id === activeId ? "active" : ""}
                    key={item.id}
                    onClick={() => {
                      setUseCase(item.title);
                      setActiveId(item.id);
                      setImg(item.img);
                    }}
                  >
                    <li>{item.title}</li>
                  </a>
                ))}
              </ul>
            </div>
          </div>

          <div className="contentsDesc col-lg-9 col-sm-12">
            <div
              className={`card ${activeId % 2 === 0 ? "green-border" : "accent-border"
                }`}
            >

              <h4>
                <FormattedMessage id={"use_case"} /> :{" "}
                <span className="pl"><br className="only-mobile" />{useCase}</span>
                {img ? <img src={img} alt="CommonUseCases" margin-left="10px" height="100px" width="auto" /> : null}

              </h4>

              {description.map((item) => (
                <p>{item}</p>
              ))}
              <Link
                to={link}
                className={activeId % 2 === 0 ? "primary" : "accent"}
              >
                <FormattedMessage id={"read_more"} />
              </Link>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Index;
